var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0562 9.85938L13.6812 9.23438C13.8 9.11563 14 9.2 14 9.36563V14.5C14 15.3281 13.3281 16 12.5 16H1.5C0.671875 16 0 15.3281 0 14.5V3.5C0 2.67188 0.671875 2 1.5 2H10.6344C10.8 2 10.8844 2.20312 10.7656 2.31875L10.1406 2.94375C10.1062 2.97812 10.0562 3 10.0094 3H1.5C1.225 3 1 3.225 1 3.5V14.5C1 14.775 1.225 15 1.5 15H12.5C12.775 15 13 14.775 13 14.5V9.99063C13 9.94063 13.0187 9.89375 13.0562 9.85938ZM17.6156 3.88438L7.85 13.65L4.72813 13.9969C4.30938 14.0437 3.95625 13.6906 4.00313 13.2719L4.35 10.15L14.1156 0.384375C14.6281 -0.128125 15.4594 -0.128125 15.9719 0.384375L17.6156 2.02813C18.1281 2.54063 18.1281 3.37188 17.6156 3.88438ZM14.6906 5.39687L12.6062 3.3125L5.30625 10.6094L5.04688 12.9563L7.39375 12.6969L14.6906 5.39687ZM16.9094 2.73438L15.2656 1.09063C15.1469 0.971875 14.9469 0.965625 14.825 1.09063L13.3125 2.60313L15.3969 4.6875L16.9094 3.175C17.0312 3.05625 17.0312 2.85625 16.9094 2.73438Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1e3b1557c959984aa926ec415093908e.svg";
export { ForwardRef as ReactComponent };